import { createStore, applyMiddleware } from "redux";
import storage from "redux-persist/lib/storage";

import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";

import appReducer from "./reducers.js";

const persistConfig = {
  key: "__mobile-connection__",
  keyPrefix: "",
  storage,
};

const persistedReducer = persistReducer(persistConfig, appReducer);

export const store = createStore(persistedReducer, applyMiddleware(thunk));

export const persistor = persistStore(store);
